calendars-daily
  .row
    .col-md-1
      .date
        span.year.text-secondary {opts.year}
        span.day_and_month(style="background: {bg_date()}")
          span.month {opts.month}
          span.day {opts.day}
          span.week { this.locale()['week_' + opts.week] }
    .col-md-11.data
      .phase-wrap(if="{has_design()}")
        calendars-phase(tag-scope="{tagScope}" phase-id="{design_id()}")
      .phase-wrap(if="{has_modeling()}")
        calendars-phase(tag-scope="{tagScope}" phase-id="{modeling_id()}")
      .phase-wrap(if="{has_casting()}")
        calendars-phase(tag-scope="{tagScope}" phase-id="{casting_id()}")
        calendars-material_lots(if="{opts.material_lots}" tag-scope="{this.tagScope}.material_lots")
      .phase-wrap(if="{has_finishing()}")
        calendars-phase(tag-scope="{tagScope}" phase-id="{finishing_id()}")
      .phase-wrap(if="{has_process()}")
        calendars-phase(tag-scope="{tagScope}" phase-id="{process_id()}")
      .phase-wrap(if="{has_check()}")
        calendars-phase(tag-scope="{tagScope}" phase-id="{check_id()}")
      .phase-wrap(if="{has_delivery()}")
        calendars-phase(tag-scope="{tagScope}" phase-id="{delivery_id()}")
      .phase-wrap(if="{has_others()}")
        calendars-phase(tag-scope="{tagScope}" phase-id="{others_id()}")
  script(type="typescript").
    this.mixin('calendars.daily');
  style(scoped).
    :scope > .row {
      padding: 16px 20px;
      margin-bottom: 60px;
    }
    .date {
      position: relative;
    }
    .date > span {
      display: inline-block;
    }
    .year {
      position: absolute;
      left: 0px;
      top: 0;
      font-size: .75rem;
    }
    .day_and_month {
      color: #FFF;
      margin-top: 18px;
      width: 60px;
      height: 60px;
      border-radius: 50%;
      position: relative;
    }
    .day_and_month > span {
      display: inline-block;
      position: absolute;
    }
    .month {
      left: 10px;
      top: 10px;
      font-size: 12px;
    }
    .day {
      left: 10px;
      top: 22px;
      font-size: 18px;
    }
    .week {
      left: 26px;
      top: 28px;
      font-size: 12px;
    }
    .row > .data > .phase-wrap {
      margin-bottom: 40px;
    }
